import { useQuery } from '@tanstack/react-query';
import { invoiceApi } from '../api/invoiceApi';
import type { InvoiceListFilters } from '../types/invoice.types';

export const useInvoiceList = (filters?: InvoiceListFilters) => {
  return useQuery({
    queryKey: ['invoices', filters],
    queryFn: () => invoiceApi.list(filters),
    refetchInterval: 30_000,
  });
};
